import { render, staticRenderFns } from "./Quiz1.vue?vue&type=template&id=d9b46186&"
import script from "./Quiz1.vue?vue&type=script&lang=js&"
export * from "./Quiz1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports